<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->
<div class="modal-inner-wrapper" ngDraggable [handle]="ModalHandle">
  <div class="modal-header">
    <h4 class="modal-title">
      <span *ngIf="invoice?.id">{{ 'INVOICES.INVOICES_FORM.EDIT_INVOICE' | translate }}</span>
      <span *ngIf="!invoice?.id">{{ 'INVOICES.INVOICES_FORM.ADD_INVOICE' | translate }}</span>
      <small *ngIf="invoice?.invoiceable_id"
        >{{ 'INVOICES.INVOICES_FORM.FOR' | translate }} {{ invoice.cleanInvoiceableType }}:{{
          invoice.invoiceable_id
        }}</small
      >
    </h4>
    <div
      class="btn btn-drag"
      #ModalHandle
      container="body"
      [ngbTooltip]="'REQUESTS.REQUEST_FORM.MOVE_MODAL' | translate"
    >
      <i class="far fa-expand-arrows"></i>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
<!--      <span aria-hidden="true">&times;</span>-->
    </button>
  </div>

  <ng-scrollbar class="modal-body ps">
    <form id="invoice-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
      <div class="row">
        <div class="col-sm-4">
          <app-clientable-select [parentFormGroup]="form" #clientableSelectComponent></app-clientable-select>

          <div class="company-info-wrapper">
            <div class="single-line">
              <div class="company-label">{{ 'INVOICES.INVOICES_FORM.COMPANY_VAT' | translate }}:</div>

              <div class="company-value" *ngIf="!invoice?.id">
                {{ form?.get('clientable')?.value?.vat_number || '-' }}
              </div>
              <input type="text" class="form-control" formControlName="vat_number" *ngIf="invoice?.id" />
            </div>

            <div class="single-line">
              <div class="company-label">{{ 'INVOICES.INVOICES_FORM.COMPANY_ADDRESS' | translate }}:</div>

              <div class="company-value" *ngIf="!invoice?.id">{{ form?.get('clientable')?.value?.address || '-' }}</div>
              <input type="text" class="form-control" formControlName="client_address" *ngIf="invoice?.id" />
            </div>

            <div class="single-line" *ngIf="invoice?.id">
              <div class="company-label">{{ 'INVOICES.INVOICES_FORM.CLIENT_NAME' | translate }}:</div>

              <input type="text" class="form-control" formControlName="client_name" />
            </div>

            <div class="single-line">
              <div class="company-label">{{ 'INVOICES.INVOICES_FORM.REGISTRATION_NUMBER' | translate }}:</div>

              <div class="company-value" *ngIf="!invoice?.id">
                {{ form?.get('clientable')?.value?.registration_number || '-' }}
              </div>
              <input type="text" class="form-control" formControlName="registration_number" *ngIf="invoice?.id" />
            </div>

            <div class="single-line">
              <div class="company-label">{{ 'INVOICES.INVOICES_FORM.RESPONSIBLE_PERSON' | translate }}:</div>

              <div class="company-value" *ngIf="!invoice?.id">
                {{ form?.get('clientable')?.value?.responsible_person || '-' }}
              </div>
              <input type="text" class="form-control" formControlName="responsible_person" *ngIf="invoice?.id" />
            </div>
          </div>
        </div>
        <div class="col-sm-5 offset-md-3">
          <div class="row">
            <div class="col-sm-6">
              <app-company-select
                (select)="companyChange()"
                [parentFormGroup]="form"
                [includes]="'bank_accounts.currency'"
              ></app-company-select>

              <div class="form-group">
                <label>{{ 'INVOICES.INVOICES_FORM.DATE' | translate }}</label>
                <app-date-picker [FormControl]="form.get('date')"></app-date-picker>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>{{ 'INVOICES.INVOICES_FORM.TYPE' | translate }}</label>
                <app-type-select
                  (select)="getNextNumber()"
                  [parentFormGroup]="form"
                  [passFormControlName]="'type_id'"
                  [groupType]="'invoice'"
                  [readonly]="this.invoice && this.invoice.id"
                >
                </app-type-select>
              </div>

              <div class="form-group">
                <label>{{ 'INVOICES.INVOICES_FORM.DUE_DATE' | translate }}</label>
                <app-date-picker [FormControl]="form.get('due_date')" [required]="false"></app-date-picker>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="invoice?.invoiceable_id && invoice?.invoiceable_type">
            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'INVOICES.INVOICES_FORM.DEPOSIT_PERCENT' | translate }}</label>
                <input type="number" class="form-control" formControlName="deposit_percent" />
              </div>
            </div>
            <div class="col-sm-10">
              <div class="form-group">
                <label>{{ 'INVOICES.INVOICES_FORM.INVOICES' | translate }}</label>
                <app-invoices-select
                  [FormControl]="form.get('deposit_invoices')"
                  [invoiceableId]="invoice.invoiceable_id"
                  [invoiceableType]="invoice.invoiceable_type"
                  [invoiceType]="InvoiceType.ORIGINAL"
                ></app-invoices-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6" *ngIf="form.get('deposit_percent').value">
              <div class="form-group">
                <label>{{ 'INVOICES.INVOICES_FORM.BALANCE_DUE_DATE' | translate }}</label>
                <app-date-picker [FormControl]="form.get('balance_due_date')" [required]="false"></app-date-picker>
              </div>
            </div>
          </div>

          <div *ngIf="invoice?.invoiceable?.sale">
            <div class="modal-section-title">{{ 'INVOICES.INVOICES_FORM.ADDITIONAL_INFO' | translate }}</div>

            <div class="additional-info">
              <div class="row">
                <div class="col-sm-3">
                  {{ 'INVOICES.INVOICES_FORM.SALE_ID' | translate }}:
                  <a
                    [routerLink]="['/sales/view']"
                    [queryParams]="{ id: invoice?.invoiceable?.sale?.id }"
                    target="_blank"
                    class="btn-link fw-bold"
                  >
                    {{ invoice?.invoiceable?.sale?.id }}
                  </a>
                </div>

                <div class="col-sm-9">
                  {{ 'INVOICES.INVOICES_FORM.CLIENT' | translate }}:
                  <a
                    [routerLink]="['/clients/view']"
                    [queryParams]="{ id: invoice?.invoiceable?.sale?.client?.id }"
                    target="_blank"
                    class="btn-link fw-bold"
                  >
                    {{ invoice?.invoiceable?.sale?.client?.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table">
        <thead>
          <tr>
            <th></th>
            <th style="width: 200px; min-width: 200px">{{ 'INVOICES.INVOICES_FORM.NAME' | translate }}</th>
            <th>{{ 'INVOICES.INVOICES_FORM.DESCRIPTION' | translate }}</th>
            <th style="width: 100px; min-width: 100px">{{ 'INVOICES.INVOICES_FORM.ACCOUNT' | translate }}</th>
            <th style="width: 100px; min-width: 100px">{{ 'INVOICES.INVOICES_FORM.QUANTITY' | translate }}</th>
            <th style="width: 100px; min-width: 100px">{{ 'INVOICES.INVOICES_FORM.UNIT_PRICE' | translate }}</th>
            <th style="width: 100px; min-width: 100px">{{ 'INVOICES.INVOICES_FORM.LINE_TOTAL' | translate }}</th>
            <th style="width: 60px; min-width: 60px; text-align: right">
              <button
                (click)="addLine()"
                type="button"
                class="btn btn-primary btn-ico"
                [ngbTooltip]="'INVOICES.INVOICES_FORM.ADD_LINE' | translate"
                container="body"
                *ngIf="!saveToShowBool()"
              >
                <i class="fal fa-plus"></i>
              </button>
            </th>
          </tr>
        </thead>

        <tbody *ngIf="saveToShowBool()">
          <tr>
            <td colspan="8" class="theme-color-danger">
              {{ 'INVOICES.INVOICES_FORM.ITEMS_WILL_SHOW_AFTER_SAVE_MSG' | translate }}
            </td>
          </tr>
        </tbody>

        <ng-container formArrayName="items">
          <tbody
            *ngFor="let item of form.get('items')?.controls; let i = index"
            [formGroupName]="i"
            [ngClass]="{ colored: i % 2 == 0 }"
            class="item-tbody"
          >
            <tr>
              <td class="pe-0">
                <div class="d-flex flex-column" *ngIf="form.get('items')?.controls.length != 1">
                  <button
                    *ngIf="i != 0"
                    (click)="moveUp(i)"
                    type="button"
                    class="btn btn-success btn-ico btn-sorting mb"
                    [ngbTooltip]="'INVOICES.INVOICES_FORM.MOVE_UP' | translate"
                    container="body"
                  >
                    <i class="fal fa-arrow-up"></i>
                  </button>

                  <button
                    *ngIf="i + 1 != form.get('items')?.controls.length"
                    (click)="moveDown(i)"
                    type="button"
                    class="btn btn-success btn-ico btn-sorting"
                    [ngbTooltip]="'INVOICES.INVOICES_FORM.MOVE_DOWN' | translate"
                    container="body"
                  >
                    <i class="fal fa-arrow-down"></i>
                  </button>
                </div>
              </td>

              <td>
                <div class="form-group">
                  <input type="text" class="form-control" formControlName="name" />
                </div>
              </td>

              <td>
                <div class="form-group">
                  <textarea
                    #descTA
                    class="form-control description-textarea"
                    [rows]="1"
                    [cols]="30"
                    formControlName="description"
                    pInputTextarea
                    autoResize="true"
                  ></textarea>
                </div>
              </td>

              <td>
                <app-type-select
                  [selectFirst]="true"
                  [parentFormGroup]="form.get('items')['controls'][i]"
                  [passFormControlName]="'account_id'"
                  [groupType]="'invoice_account'"
                >
                </app-type-select>
              </td>

              <td>
                <div class="form-group">
                  <input type="text" class="form-control" formControlName="quantity" />
                </div>
              </td>

              <td>
                <div class="form-group">
                  <input type="text" class="form-control" formControlName="unit_price" />
                </div>
              </td>

              <td>
                {{ item.get('quantity').value * item.get('unit_price').value | number : '1.2-2' }}
              </td>

              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <input
                    class="me-2"
                    type="checkbox"
                    formControlName="apply_to_net_amount"
                    [ngbTooltip]="'INVOICES.INVOICES_FORM.APPLY_TO_NET_PRICE' | translate"
                    container="body"
                  />

                  <button
                    (click)="removeLine(i)"
                    type="button"
                    class="btn btn-danger btn-ico"
                    [ngbTooltip]="'INVOICES.INVOICES_FORM.REMOVE_LINE' | translate"
                    container="body"
                  >
                    <i class="fal fa-times"></i>
                  </button>
                </div>
              </td>
            </tr>

            <tr *ngIf="item?.get('invoiceable_item')?.value">
              <td colspan="4" class="border-0">
                <div class="row">
                  <div class="col-sm-2">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.CHECK_IN' | translate }}</div>
                    {{ item?.get('invoiceable_item')?.value?.sale_offer_item?.check_in }}
                  </div>
                  <div class="col-sm-1">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.NIGHTS' | translate }}</div>
                    {{
                      getNightsCount(
                        item?.get('invoiceable_item')?.value?.sale_offer_item?.check_in,
                        item?.get('invoiceable_item')?.value?.sale_offer_item?.check_out
                      )
                    }}
                  </div>
                  <div class="col-sm-2">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.CHECK_OUT' | translate }}</div>
                    {{ item?.get('invoiceable_item')?.value?.sale_offer_item?.check_out }}
                  </div>
                  <div class="col-sm-1">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.COUNT' | translate }}</div>
                    {{ item?.get('invoiceable_item')?.value?.sale_offer_item?.count }}
                  </div>
                  <div class="col-sm-2">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.TYPE' | translate }}</div>
                    {{ item?.get('invoiceable_item')?.value?.sale_offer_item?.type?.value }}
                  </div>
                  <div class="col-sm-2">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.PRICE_PER_NIGHT' | translate }}</div>
                    {{ item?.get('invoiceable_item')?.value?.sale_offer_item?.price | number : '1.2-2' }}
                  </div>
                  <div class="col-sm-2">
                    <div class="super-small-text">{{ 'INVOICES.INVOICES_FORM.PRICE_TOTAL' | translate }}</div>
                    {{
                      item?.get('invoiceable_item')?.value?.sale_offer_item?.price *
                        getNightsCount(
                          item?.get('invoiceable_item')?.value?.sale_offer_item?.check_in,
                          item?.get('invoiceable_item')?.value?.sale_offer_item?.check_out
                        ) *
                        item?.get('invoiceable_item')?.value?.sale_offer_item?.count | number : '1.2-2'
                    }}
                  </div>
                </div>
              </td>
              <td colspan="4" class="border-0"></td>
            </tr>
          </tbody>
        </ng-container>

        <tbody>
          <tr>
            <td colspan="6" class="text-end fw-bold">
              {{ 'INVOICES.INVOICES_FORM.SUBTOTAL' | translate }}
            </td>
            <td>
              {{ totals?.price | number : '1.2-2' }}
            </td>
            <td style="text-align: right">
              <button
                (click)="addLine()"
                type="button"
                class="btn btn-primary btn-ico"
                [ngbTooltip]="'INVOICES.INVOICES_FORM.ADD_LINE' | translate"
                container="body"
                *ngIf="!saveToShowBool()"
              >
                <i class="fal fa-plus"></i>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="text-end fw-bold">
              {{ 'INVOICES.INVOICES_FORM.TAX_RATE' | translate }}
            </td>
            <td>
              <div class="form-group">
                <app-type-select
                  (select)="form.get('tax').patchValue($event)"
                  [parentFormGroup]="form"
                  [passFormControlName]="'tax_id'"
                  [groupType]="'tax_rates'"
                >
                </app-type-select>
              </div>
            </td>
            <td></td>
          </tr>

          <tr>
            <td colspan="6" class="text-end fw-bold">
              {{ 'INVOICES.INVOICES_FORM.TOTAL' | translate }}
            </td>
            <td>
              {{
                totals?.price + (totals?.price * (form?.get('tax')?.value?.real_value || 0)) / 100 | number : '1.2-2'
              }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </div>

      <div class="row">
        <div class="col-sm-2">
          <div class="form-group">
            <div class="label d-flex justify-content-between align-items-center">
              <div>
                {{ 'INVOICES.INVOICES_FORM.NUMBER' | translate }}
              </div>

              <small class="fw-bold" *ngIf="nextNumber">
                ({{ 'INVOICES.INVOICES_FORM.NEXT_NUMBER' | translate }}: {{ nextNumber }})
              </small>

              <div *ngIf="!invoice?.id">
                <input type="checkbox" class="auto-checkbox" id="auto" formControlName="auto_number" />
                <label for="auto">
                  {{ 'INVOICES.INVOICES_FORM.AUTO' | translate }}
                </label>
              </div>
            </div>
            <input
              type="number"
              class="form-control"
              formControlName="number"
              [readOnly]="form.get('auto_number').value"
            />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'INVOICES.INVOICES_FORM.REFERENCE' | translate }}</label>
            <input type="text" class="form-control" formControlName="reference" />
          </div>
        </div>

        <div class="col-sm-1">
          <app-currency-select [parentFormGroup]="form"></app-currency-select>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'INVOICES.INVOICES_FORM.PAYMENT_METHOD' | translate }}</label>
            <app-type-select
              (select)="paymentMethodChange()"
              [parentFormGroup]="form"
              [passFormControlName]="'payment_method_id'"
              [groupType]="'payment_method'"
            >
            </app-type-select>
          </div>
        </div>

        <div class="col-sm-3" *ngIf="form.get('payment_method_id').value == PaymentMethods.BANK_TRANSFER">
          <app-bank-account-select [parentFormGroup]="form" [data]="form?.get('company')?.value?.bank_accounts">
          </app-bank-account-select>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label>{{ 'INVOICES.INVOICES_FORM.PUBLIC_NOTE' | translate }}</label>
            <textarea
              class="form-control textarea"
              formControlName="public_note"
              pInputTextarea
              autoResize="true"
            ></textarea>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group">
            <label>{{ 'INVOICES.INVOICES_FORM.PRIVATE_NOTE' | translate }}</label>
            <textarea
              class="form-control textarea"
              formControlName="private_note"
              pInputTextarea
              autoResize="true"
            ></textarea>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" formControlName="paid" id="invoice-form-paid" />
            <label class="custom-control-label" for="invoice-form-paid">
              {{ 'INVOICES.INVOICES_FORM.PAID' | translate }}
            </label>
          </div>
        </div>
      </div>
    </form>
  </ng-scrollbar>

  <div class="modal-footer d-flex justify-content-between">
    <div>
      <button
        [disabled]="form.invalid"
        *ngIf="invoice && invoice.id && invoice.company_id !== CompaniesEnum.TFT"
        (click)="download()"
        class="btn btn-success btn-xs me-3"
      >
        {{ 'INVOICES.INVOICES_FORM.SAVE_AND_DOWNLOAD' | translate }}
      </button>

      <div
        *ngIf="invoice && invoice.id && invoice.company_id === CompaniesEnum.TFT"
        ngbDropdown
        class="d-inline-block"
        container="body"
      >
        <button class="btn btn-success btn-xs me-3" id="invoices-dropdown2" ngbDropdownToggle>
          {{ 'INVOICES.INVOICES_FORM.SAVE_AND_DOWNLOAD' | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="invoices-dropdown2">
          <button ngbDropdownItem (click)="download()" [disabled]="form.invalid">EN</button>

          <button ngbDropdownItem (click)="download('bg')" [disabled]="form.invalid">BG</button>
        </div>
      </div>

      <app-payment-button
        [iconBtn]="false"
        [paymentable_id]="invoice.id"
        [paymentable_type]="LaravelModelsEnum.INVOICE"
        *ngIf="invoice?.id && invoice.type_id != InvoiceType.PROFORMA"
      ></app-payment-button>
    </div>

    <div class="d-flex">
      <button
        (click)="createInvoice()"
        *ngIf="invoice?.id && invoice.type_id == InvoiceType.PROFORMA"
        type="button"
        class="btn btn-success btn-xs me-3"
      >
        {{ 'INVOICES.INVOICES_FORM.CREATE_INVOICE' | translate }}
      </button>

      <button
        *ngIf="saveToShowBool()"
        type="button"
        class="btn btn-outline-dark btn-xs me-3"
        [disabled]="form.invalid"
        (click)="saveAndShowItems()"
      >
        {{ 'INVOICES.INVOICES_FORM.SAVE_AND_SHOW_ITEMS' | translate }}
      </button>

      <button type="submit" class="btn btn-outline-dark btn-xs" form="invoice-form" [disabled]="form.invalid">
        {{ 'INVOICES.INVOICES_FORM.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
